export const LIBRARY = 'header.library';
export const FAVORITES = 'header.favorites';
export const SETTINGS = 'header.settings';
export const LOGOUT = 'header.logout';
